import { decode, encode } from 'base64-arraybuffer'
import { isNumber, isString, uniq } from 'lodash'
import { nanoid } from 'nanoid'
import { CSV } from './csvparse'
import parse from 'html-react-parser'
import dayjs from 'dayjs'
import { getCookie } from 'cookies-next'
import { deliverableNamePrefix, undeliverableNamePrefix } from './slug'
import { UserStore } from '../state/UserStore'
import { impersonatedByEmailKeyName } from './api'
// import * as Sentry from '@sentry/nextjs'
import { passwordStrength } from 'check-password-strength'
import TurboLetterModal from '../components/Modals/TurboLetterModal'
import { ModalStore } from '../state/ModalStore'
import WentWrong from '../components/Modals/WentWrong'
import { _BATCH_PRICE_KEY } from './checkout'
import { CartAPI, CartFecther } from '../apis/CartAPI'
import { mutate } from 'swr'
import {
    AdjustmentsIcon,
    ArchiveIcon,
    BookmarkIcon,
    ColorSwatchIcon,
    FingerPrintIcon,
    HomeIcon,
    MailIcon,
} from '@heroicons/react/outline'
import RealPenLettersIcon from '../Icons/RealPenLettersIcon'
import RealPennedPostCardsIcon from '../Icons/RealPennedPostCardsIcon'
import HandWrittenLetterIcon from '../Icons/PersonalLetterIcon'
import ProfessionalLetterIcon from '../Icons/ProfessionalLetterIcon'
import SmallPostCardIcon from '../Icons/SmallPostcardIcon'
import CheckMailersIcon from '../Icons/CheckMailersIcon'

import slugify from 'slugify'
// import chalk from 'chalk'

export const wooCommerceSessionKey = 'wooCommerceSessionKey'
export const wooNonceKey = 'wooCommerceNonceKey'

export const generateId = (length = 8) => nanoid(length)
// `${performance.now()}${Math.random().toString().slice(5)}`.replace('.', '')

export function log() {
    // return console.log(...arguments)
}
export function log2() {
    // return
    // return console.log(...arguments)
}

export const mimetypes = {
    csv: 'text/csv',
    image: 'image/jpeg,image/png,image/jpg',
    doc: 'application/msword',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    pdf: 'application/pdf',
    png: 'image/png',
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    xls: 'application/vnd.ms-excel',
    zip: 'application/zip',
    font: 'application/x-font-ttf,application/x-font-otf,application/x-font-woff,application/x-font-woff2',
    image_document:
        'image/jpeg,image/png,image/jpg,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf',
}

export const textForTypes = {
    csv: 'csv',
    image: 'png, jpg, gif',
    doc: 'doc',
    docx: 'docx',
    document: 'doc, docx, pdf',
    pdf: 'pdf',
    image_document: 'png, jpg, gif, doc, docx, pdf',
    zip: 'zip',
    font: 'ttf, otf, woff, woff2',
}

export const getMimeTypes = (type) => {
    if (type === 'image_document') return mimetypes['image_document']
    if (type === 'image') return mimetypes['image']
    if (type === 'csv') return mimetypes['csv']
    if (type === 'zip') return mimetypes['zip']
    if (type === 'font') return mimetypes['font']
    if (type === 'doc' || type === 'document')
        return (
            mimetypes['doc'] + ',' + mimetypes['docx'] + ',' + mimetypes['pdf']
        )
}

export const convertFilesTobase64 = async (files) => {
    const convertTobase64 = async (file) => {
        const buffer = Buffer.from(await new Response(file).arrayBuffer())
        const data = encode(buffer)
        return {
            name: file.name,
            path: file.path,
            type: file.type,
            size: file.size,
            data,
        }
    }

    if (!Array.isArray(files)) return convertTobase64(files)

    let dataFiles = []
    for (const file of files) {
        const base64 = await convertTobase64(file)
        dataFiles.push(base64)
    }
    return dataFiles
}
export const convertBase64ToFiles = (dataFiles) => {
    const getFile = (data) => {
        const buffer = decode(data.data)
        return new File([buffer], data.name, {
            type: data.type,
            size: data.size,
            path: data.path,
        })
    }

    if (!Array.isArray(dataFiles)) return getFile(dataFiles)

    let files = []
    for (const data of dataFiles) {
        const file = getFile(data)
        files.push(file)
    }
    return files
}

export const prepareCSVFileSuffix = (
    order_id,
    shouldAddMailingDuplicate,
    shouldAddPropertyDuplicate,
) => {
    return `${
        shouldAddPropertyDuplicate ? 'removed_property_duplicates_' : ''
    }${
        shouldAddMailingDuplicate ? 'removed_mailing_duplicates_' : ''
    }Lead_List.csv`
}

export const convertSmartySteetValidJsonToFiles = async (
    SmartySteetJson,
    shouldIncludeInvalids,
    _orderCreated,
) => {
    let files = []
    const mergedFile = {
        valids: [],
        invalids: [],
    }

    let removedMailingDuplicatesArray = []
    let removedPropertyDuplicatesArray = []

    /**
     * we will merge all files and create one file
     * */

    let headers = []

    for (const file of SmartySteetJson) {
        let { valids: orgValids, invalids: orgInvalids } = file.data

        let valids = [...orgValids]
        let invalids = [...orgInvalids]

        if (valids.length > 0) {
            const header = valids.shift()
            headers = [...headers, header]
        }

        if (valids.length < 1) continue

        valids = valids.map((valid) => {
            return {
                ...valid,
                order: _orderCreated.id,
            }
        })
        invalids = invalids.map((invalid) => {
            return {
                ...invalid,
                order: _orderCreated.id,
            }
        })

        mergedFile.valids = [...mergedFile.valids, ...valids]
        mergedFile.invalids = [...mergedFile.invalids, ...invalids]

        removedMailingDuplicatesArray.push(file.removedMailingDuplicates)
        removedPropertyDuplicatesArray.push(file.removedPropertyDuplicates)
    }

    log('headers', headers)

    const csvHeaders = uniq(headers.flatMap(Object.keys)).reduce(
        (acc, header) => ({ ...acc, [header]: `<<${header}>>` }),
        {},
    )

    log('csvHeaders', csvHeaders)

    mergedFile.valids = [...[csvHeaders], ...mergedFile.valids]
    mergedFile.invalids = [...[csvHeaders], ...mergedFile.invalids]

    const shouldAddMailingDuplicate = removedMailingDuplicatesArray.some(
        (item) => item,
    ) // if even one item is true

    const shouldAddPropertyDuplicate = removedPropertyDuplicatesArray.some(
        (item) => item,
    ) // if even one item is true

    const csvSuffix = prepareCSVFileSuffix(
        _orderCreated.id,
        shouldAddMailingDuplicate,
        shouldAddPropertyDuplicate,
    )

    const csvFile = await CSV.createFile(
        mergedFile.valids,
        deliverableNamePrefix + csvSuffix,
    )

    // `#${_orderCreated.id}-` +
    // `#${_orderCreated.id}-` +

    files.push(csvFile) // Deliverable

    if (shouldIncludeInvalids) {
        const InvalidCSVFile = await CSV.createFile(
            mergedFile.invalids,
            undeliverableNamePrefix + csvSuffix,
        )
        files.push(InvalidCSVFile) // UnDeliverable
    }

    return files
}

export const convertToArrayToLines = (array) => {
    let string = ''
    for (const item of array) {
        const url = convertSpecialCharsFromURL(item.url)
        string += `<a href='${url}'>${item.name}</a>\n`
    }
    return string
}

export const convertURLToATag = (string) => {
    const url = convertSpecialCharsFromURL(string)
    const aTag = `<a href='${url}'>${string}</a>\n`
    return aTag
}

export const removeSpecialChars = (fileName) => {
    const encodings = {
        '+': '%2B',
        '!': '%21',
        '"': '%22',
        '#': '%23',
        $: '%24',
        '&': '%26',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '*': '%2A',
        ',': '%2C',
        ':': '%3A',
        ';': '%3B',
        '=': '%3D',
        '?': '%3F',
        '@': '%40',
    }

    for (const key in encodings) {
        fileName = String(fileName).replaceAll(key, '')
    }

    fileName = String(fileName).replace(/ /g, '_')

    return fileName
}

export const convertSpecialCharsFromURL = (url) => {
    return String(url).replace('#', '%23')
}

export const getNameAndExtensionFromFileName = (filename) => {
    const lastIndex = filename.lastIndexOf('.')
    const length = filename.length
    const name = filename.slice(0, lastIndex)
    const extension = filename.slice(lastIndex, length)
    return [name, extension]
}

export const formatuseFormErrors = (errors) => {
    const errorArray = []
    for (const error of Object.values(errors)) {
        errorArray.push(`${error['message']}`)
    }
    return errorArray
}

export const formatCurrency = (number, toFractions = 0) => {
    number = parseFloat(number)
    if (number == 0 && toFractions == 0) return 0

    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: toFractions,
    }).format(number)
}

export const formatNumberLocal = (number, toFractions = 0) => {
    return new Intl.NumberFormat('en-US', {
        maximumFractionDigits: toFractions,
    }).format(number)
}

export const formatPrice = (num, decimalPoint = 2) => {
    // num = String(num)
    // const spliLenth = num.split('.').length > 1 ? num.split('.')[1].length : 0
    // const zeroLength = spliLenth >= 3 ? 3 : 2
    return Number(num).toFixed(decimalPoint)
}

export const preparePrice = (price) => {
    // woocommcrece price are in cents
    return formatPrice(price / 100)
}

/**
 * Util function to return a promise which is resolved in provided milliseconds
 */
export function sleep(millSeconds) {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve()
        }, millSeconds)
    })
}

export const isSmartyStreetLimitError = (apiError) => {
    return apiError?.id === 1637696258
}

export const matchStripString = (string) =>
    string
        .replace('Envelopes', 'Envelope')
        .replace('+$65', '')
        .replace('(upload required)', '')
        .replace(/ /g, '')
        .replace(/-/g, '')
        .replace(/–/g, '') // this is special case, looks same as - but its not.
        .replace(/_/g, '')
        .replace(/-/g, '')
        .replace(/,/g, '')
        .replace(/\(/g, '')
        .replace(/\)/g, '')
        .toLowerCase()

export const prepeImageStringToMatch = (string) =>
    matchStripString(string).replace(/min/g, '')

export const prepareAndparseHTML = (html) => {
    html = html.replaceAll('<<', '&lt;&lt;')
    html = html.replaceAll('>>', '&gt;&gt;')
    return parse(html)
}
export const parseHTML = (html) => parse(html)

const removePricingTable = (htmlString) => {
    if (typeof window !== 'undefined') {
        const div = document.createElement('div')
        div.innerHTML = htmlString
        const table = div.querySelector('table#iseqchart')
        if (table) {
            table.remove()
        }
        log('div.innerHTML', div.innerHTML)
        return div.innerHTML
    }
    return htmlString
}

export const ParseWordPressHTML = ({ children, className = '' }) => {
    const parsedHTML = removePricingTable(children)

    return (
        <div className={`w-full ${className}`}>
            <div className="overflow-x-auto w-full">
                <div className="inline-block min-w-full py-2 align-middle">
                    <div className="raw-html">{parseHTML(parsedHTML)}</div>
                </div>
            </div>
        </div>
    )
}

export function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export const isLocalhost =
    typeof window !== 'undefined' && window.location.hostname !== 'localhost'

export const isLocal = process.env.NEXT_PUBLIC_STORE_SUFFIX === 'local'
export const isDev = process.env.NEXT_PUBLIC_STORE_SUFFIX === 'dev'

export const formatToPhone = (value) => {
    value = String(value)

    if (!value && value.trim() === '') return null

    value = value.replace(/\D/g, '') //this enforces that input is numeric

    const input = value.substring(0, 10) // First ten digits of input only
    const areaCode = input.substring(0, 3)
    const middle = input.substring(3, 6)
    const last = input.substring(6, 10)

    if (input.length > 6) {
        return `(${areaCode}) ${middle} - ${last}`
    } else if (input.length > 3) {
        return `(${areaCode}) ${middle}`
    } else if (input.length > 0) {
        return `(${areaCode}`
    }
}

export const convertToInteger = (value) => {
    return isNumber(value) ? parseInt(value) : 1
}

export const formatOrderDate = (date) => {
    const converted = dayjs(date).format('MM/DD/YYYY')
    return converted === 'Invalid Date' ? date : converted
}

export const openChatBox = () => {
    if (window) {
        window.HubSpotConversations.widget.open()
    }
}

export const stopEscKey = (e) => {
    if (e.keyCode == 27) {
        e.stopImmediatePropagation()
    }
}

export const isDEVMODE = () => {
    return process.env?.NEXT_PUBLIC_DEBUG === 'true'
}

export const getErrorMessage = (error) => {
    // Sentry.captureException(error)
    if (error?.response?.data?.data?.message) {
        return error.response.data.data.message
    } else if (error?.response?.data?.message) {
        return error.response.data.message
    } else {
        return (
            error.message || 'Something went wrong, please contact to support.'
        )
    }
}

export const getPasswordClassName = (password) => {
    const strength = passwordStrength(password).value
    const classNames =
        strength === 'Too weak'
            ? 'text-red-600'
            : strength === 'Weak'
            ? 'text-gray-500'
            : strength === 'Medium'
            ? 'text-amber-500'
            : 'text-green-600'

    return [classNames, strength]
}

export const _isLoggedIn = () => {
    const user = UserStore.getState().user
    return user?.ID || false
}

export const _isAdministrator = () => {
    const user = UserStore.getState().user
    return user?.role === 'administrator'
}

export const _canLoginAsCustomer = (_user) => {
    const user = _user || UserStore.getState().user
    return user?.role === 'administrator' || user?.role === 'shop_manager'
}

export const _isImpersonated = () => {
    const user = UserStore.getState().user
    return user?.impersonated
}

export const _getImpersonatedByEmail = () => {
    try {
        const email = getCookie(impersonatedByEmailKeyName)
        return email || null
    } catch (e) {
        return null
    }
}

/**
 * Filter out impersonation metadata from orders before displaying to frontend
 * Keeps the metadata in backend but hides it from frontend users
 */
export const filterImpersonationMetadataFromOrder = (order) => {
    if (!order) return order

    const filteredOrder = { ...order }

    // Filter order-level meta_data
    if (filteredOrder.meta_data && Array.isArray(filteredOrder.meta_data)) {
        filteredOrder.meta_data = filteredOrder.meta_data.filter(
            (meta) =>
                meta.key !== '_order_placed_by_impersonated_user' &&
                meta.key !== '_placed_by_impersonated_user_email' &&
                meta.key !== '_cart_items_added_by_impersonated_user' &&
                meta.key !== '_cart_items_added_by_admin_email',
        )
    }

    // Filter line item meta_data
    if (filteredOrder.line_items && Array.isArray(filteredOrder.line_items)) {
        filteredOrder.line_items = filteredOrder.line_items.map((lineItem) => {
            if (lineItem.meta_data && Array.isArray(lineItem.meta_data)) {
                return {
                    ...lineItem,
                    meta_data: lineItem.meta_data.filter(
                        (meta) =>
                            meta.key !== '_added_by_impersonated_user_email',
                    ),
                }
            }
            return lineItem
        })
    }

    return filteredOrder
}

/**
 * Filter impersonation metadata from an array of orders
 */
export const filterImpersonationMetadataFromOrders = (orders) => {
    if (!Array.isArray(orders)) return orders
    return orders.map(filterImpersonationMetadataFromOrder)
}

export const getWooSessionKeysFromObject = (cookieObject) => {
    // && cookieObject[wooNonceKey]
    if (cookieObject[wooCommerceSessionKey]) {
        return {
            Cookie: cookieObject[wooCommerceSessionKey],
            // nonce: cookieObject[wooNonceKey] || '',
        }
    }
    return {}
}

// {
//     "namespace": "olm-plugin/v1/cart",
//     "data": {
//             "id": 1138,
//             "quantity": 10,
//             "item_data": [{
//                 "name" : "_something_2",
//                 "value" : "something"
//             }]
//     }
// }

export const handleTurboLetters = (router) => {
    const addModal = ModalStore.getState().add

    // this is to handle turbo letters redirection and cookies
    const isRedirectedfromTurboLetters =
        router?.query?.redirect === 'turboletters'
    // document.referrer.includes('turboletters.com')
    log('isRedirectedfromTurboLetters', isRedirectedfromTurboLetters)
    log('isRedirectedfromVercel', document.referrer.includes('vercel.com'))

    if (isRedirectedfromTurboLetters) {
        addModal(<TurboLetterModal />)
    }
}

export const makeObjectRowProperCase = (row) => {
    let modifiedRow = {}

    const excludedKeys = ['retwebsite', 'retname', 'retaddress']

    Object.keys(row).forEach((key) => {
        if (isString(row[key]) && !excludedKeys.includes(key)) {
            modifiedRow[key] = makeSentenceCaptilize(row[key])
            if (key.includes('st') || key === 'retarea') {
                modifiedRow[key] = twoCharUppercase(modifiedRow[key])
            }
        } else modifiedRow[key] = row[key]
    })
    return modifiedRow
}

export const twoCharUppercase = (sentence) => {
    let arr = String(sentence).split(' ')
    for (var i = 0; i < arr.length; i++) {
        if (arr[i].length === 2) {
            arr[i] = arr[i].toUpperCase()
        }
    }
    return arr.join(' ')
}

export const makeSentenceCaptilize = (sentence) => {
    let arr = String(sentence).toLowerCase().split(' ')
    //loop through each element of the array and capitalize the first letter.
    for (var i = 0; i < arr.length; i++) {
        arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1)
    }
    return arr.join(' ')
}

export function showWentWrongModal(
    msg,
    title = 'Something Went Wrong, Please try again.',
) {
    const addModal = ModalStore.getState().add
    addModal(<WentWrong {...{ title, msg }} />)
}

export const handleMaybeRedirect = (router) => {
    const requestedPath = router.asPath

    const redirectObject = [
        // {
        //     from: 'skip-trace-phone-email-append',
        //     to: '/503',
        // },
    ]

    const toRedirectItem = redirectObject.find((item) =>
        requestedPath.includes(item.from),
    )
    if (toRedirectItem) {
        router.push(toRedirectItem.to)
    }
}

export const fbTrackPurchase = ({ total, order_id }) => {
    if (window.fbq) {
        window.fbq('track', 'Purchase', {
            currency: 'USD',
            value: total,
            order_id,
        })
    }
    if (window.gtag) {
        window.gtag('event', 'conversion', {
            send_to: 'AW-10868336784/wlGBCPPGo4cYEJDRtr4o',
            value: total,
            currency: 'USD',
            transaction_id: order_id,
        })
    }
}

export const fbTrackAddToCart = (items) => {
    const items_data = items.map((item) => {
        const page_title = document.title
        const { value: price } = item.item_data.find(
            (key) => key.name === _BATCH_PRICE_KEY,
        )
        const value = parseInt(item.quantity) * parseFloat(price)
        return {
            currency: 'USD',
            value,
            page_title,
        }
    })

    if (window.fbq) {
        for (const item of items_data) {
            window.fbq('track', 'AddToCart', item)
        }
    }
}

export const trackFromSubmission = (formName) => {
    if (window.fbq) {
        window.fbq('track', 'Lead', {
            content_name: formName,
        })
    }
    if (window.gtag) {
        window.gtag('event', 'FormSubmitted', {
            event_category: 'Lead',
            event_label: formName,
        })
    }
}

export const reloadCart = async (cart) => {
    if (!cart) {
        cart = await CartFecther(CartAPI.getCart)
    }
    await mutate(CartAPI.getCart, cart)
    return cart
}

export const getSeperateHTMLLinksofFilesFromDeliverableFilesMeta = (value) => {
    const values = String(value).trim().split('\n')
    return values
}

export const removeQueryParam = (param, router) => {
    const { pathname, query } = router
    const params = new URLSearchParams(query)
    params.delete(param)
    router.replace({ pathname, query: params.toString() }, undefined, {
        shallow: true,
    })
}

export const humanReadbleOrderStatus = (status) => {
    const statusObject = {
        'on-hold': 'Pending Payment',
        'pending-payment': 'Waiting for Payment - Use Pay Link',
        completed: 'Mailed Completed',
        cancelled: 'Cancelled',
        refunded: 'Order Refunded',
        failed: 'Order Failed',
        placeholder: 'Prepaid Order',
        subscription: 'Subscription',
        'on-hold-paid': 'On Hold - Call to Schedule',
        pending: 'Waiting for Payment - Use Pay Link',
        'completed-serv-su': 'Service Completed',
        'invoice-sent': 'Order Updated - Use Pay Link',
        'invoice-paid': 'Invoice Paid',
        production: 'In Production',
        'proof-approved': 'Proof Approved',
        'preparing-proof': 'Preparing Campaign Proof',
        'waiting-for-custo': 'Waiting for Proof Approval',
        'waiting-on-files': 'Waiting on Files',
        processing: 'Preparing Proof',
        'proof-denied': 'Proof Denied',
        'list-reuploaded-r': 'New List - Resending Proof',
        'mail-data': 'In Production',
        'print-file': 'In Production',
        'printing-envelope': 'In Production',
        'sent-to-printer': 'Sent to Printer',
        'deal-lost': 'Deal Lost',
    }

    return statusObject[status] || status
}

export const hasATag = (str) => {
    return /<a.*?>(.*?)<\/a>/g.test(str)
}

export const getTextBetweenTag = (str) => {
    if (!str) return ''
    return str.replace(/<\/?[^>]+>/gi, '')
}

export const joinArray = (arr, separator = ', ') => {
    return arr.join(separator)
}

export const showArrayLineSeperated = (arr, showIdx = true) => {
    return arr.map((item, idx) => (
        <p key={item}>
            {' '}
            {showIdx && idx + 1 + ' .'} {item}
        </p>
    ))
}

export const extractFilenamesFromURL = (html) => {
    log('extractFilenamesFromURL html', html)

    const stringValue = String(html || '')

    // Create a new DOMParser
    const parser = new DOMParser()
    // Use the DOMParser to parse the HTML
    const doc = parser.parseFromString(stringValue, 'text/html')
    // Get all the <a> elements
    const links = doc.getElementsByTagName('a')

    let fileNames = []

    // Iterate over the links and extract filenames
    for (let link of links) {
        const url = new URL(link.href)
        const pathSegments = url.pathname.split('/')
        const fileName = pathSegments[pathSegments.length - 1]
        fileNames.push(fileName)
    }

    if (fileNames.length > 0) return fileNames

    return stringValue
        .split('\n')
        .map((entry) => entry.trim())
        .filter(Boolean)
        .map((entry) => {
            const directUrlMatch = entry.match(/(https?:\/\/[^\s"'<>]+)/i)
            if (!directUrlMatch?.[1]) return null

            try {
                const url = new URL(directUrlMatch[1])
                const pathSegments = url.pathname.split('/')
                return pathSegments[pathSegments.length - 1] || null
            } catch {
                return null
            }
        })
        .filter(Boolean)
}

export const parseAwsS3Error = (error) => {
    // Check if the error is in JSON format (Vercel)
    if (error.data && error.data.error) {
        const code = error.data.error.code
        if (code === '413') {
            return {
                code: '413',
                message:
                    'Upload failed: The file exceeds the maximum allowed size of 20MB. Please select a smaller file and try again.',
            }
        }
        const message = error.data.error.message
        return { code, message }
    }

    // Check if the error is in XML format (AWS)
    if (typeof error === 'string' && error.startsWith('<')) {
        const parser = new DOMParser()
        const xmlDoc = parser.parseFromString(error, 'text/xml')
        const xmlError = xmlDoc.getElementsByTagName('Error')[0]
        const code =
            xmlError.getElementsByTagName('Code')[0].childNodes[0].nodeValue
        const message =
            xmlError.getElementsByTagName('Message')[0].childNodes[0].nodeValue
        return { code, message }
    }

    // Default case if the error format is not recognized
    return { code: 'UNKNOWN', message: 'Unknown error format' }
}

export const CUSTOMER_CUSTOM_IMAGES_KEY = 'custom_uploads'

export const customerCustomImages = (customer) => {
    if (!customer) return []
    const data = customer?.meta_data?.find(
        (item) => item.key === CUSTOMER_CUSTOM_IMAGES_KEY,
    )
    return data?.value || []
    // if (!Array.isArray(data?.value)) return [data?.value]
    // return data?.value
}

export const isImage = (url) => {
    const str = String(url).toLowerCase()
    return /\.(gif|jpe?g|tiff?|png|webp|bmp)$/i.test(str)
}

export const getUploadedFileName = (fileURL) => {
    const url = new URL(fileURL)
    const pathSegments = url.pathname.split('/')
    return pathSegments[pathSegments.length - 1]
}

export const NavigationTitle = ({ child }) => {
    return <span dangerouslySetInnerHTML={{ __html: child.name }} />
}

export const navigations = [
    {
        name: 'Products',
        // href: '/products',
        childrens: [
            {
                name: 'All Products',
                href: '/products',
            },
            {
                name: 'Campaigns',
                href: '#',
                childrens: [
                    {
                        name: 'Proven Mix Campaigns',
                        href: '/product/proven-mix-campaigns/',
                        description:
                            'Put your direct mail on autopilot with our high-performing, automated direct mail campaigns.',
                        icon: ColorSwatchIcon,
                    },
                    {
                        name: 'Create Your Own Campaign',
                        href: '/product/create-your-own-campaign/',
                        description:
                            'Set up a custom 3-6 touch automated campaign. You choose the pieces and the frequency, and we will take care of the rest!',
                        icon: AdjustmentsIcon,
                    },
                ],
            },
            {
                name: 'Offer Products <b>&#x2728;NEW!&#x2728;</b>',
                href: '#',
                childrens: [
                    {
                        name: '<b>Snap Pack Check Mailer (ROS)</b>',
                        href: '/product/snap-pack-check-mailers-ros/',
                        description:
                            'The highest quality snap pack checks using our proprietary offer system.',
                        icon: CheckMailersIcon,
                    },
                    {
                        name: 'Offer Letters (ROS)',
                        href: '/product/ros-letters',
                        description:
                            'Provide an instant cash offer using our proprietary offer system.',
                        icon: HomeIcon,
                    },
                ],
            },

            {
                name: 'Real Penned Products',
                href: '#',
                childrens: [
                    {
                        name: 'Real Penned Professional Letters',
                        href: '/product/real-penned-professional-letters/',
                        description:
                            'Our new Real Penned Professional Letters include a return address and mailing address written with a real blue ink pen! Use your own template or any current OLM templates.',
                        icon: RealPenLettersIcon,
                    },
                    {
                        name: 'Real Penned Personal Letters',
                        href: '/product/real-penned-letters/',
                        description:
                            'Real Penned Letters are entirely written with blue ink pens. This includes the return address, mailing address, AND your custom letter!',
                        icon: RealPenLettersIcon,
                    },
                    {
                        name: 'Real Penned Postcards',
                        href: '/product/real-penned-postcards/',
                        description:
                            'Get access to our newest product. Postcards written with actual blue ink!',
                        icon: RealPennedPostCardsIcon,
                    },
                ],
            },
            {
                name: 'Letters',
                href: '#',
                childrens: [
                    {
                        name: 'Personal Letters',
                        href: '/product/personal-letters',
                        description:
                            'Send a more personal message with our highly effective, digitally-hand written personal letters.',
                        icon: HandWrittenLetterIcon,
                    },
                    {
                        name: 'Professional Letters',
                        href: '/product/professional-letters',
                        description:
                            'This product is excellent for building brand awareness and trust with your prospects.',
                        icon: ProfessionalLetterIcon,
                    },
                ],
            },
            {
                name: 'Flyers',
                href: '#',
                childrens: [
                    {
                        name: 'Trifold Flyers',
                        href: '/product/tri-fold-flyers/',
                        description:
                            'Ditch the envelope, and use high-performing self-mailing letters without the cost!',
                        icon: BookmarkIcon,
                    },
                ],
            },
            {
                name: 'Postcards',
                href: '#',
                childrens: [
                    {
                        name: 'Postcards',
                        href: '/product/postcards',
                        description:
                            'Make a great first impression with your prospects with our high-impact postcards.',
                        icon: SmallPostCardIcon,
                    },
                ],
            },
        ],
    },
    {
        name: 'Services',
        childrens: [
            {
                name: 'Premium Lead Lists',
                href: '/premium-lead-lists',
                description:
                    'Creating a comprehensive real estate investment lead list.',
                icon: ArchiveIcon,
            },
            {
                name: 'Listsource Access',
                href: '/service/real-estate-investment-lead-lists',
                description:
                    'Creating a comprehensive real estate investment lead list.',
                icon: ArchiveIcon,
            },
            {
                name: 'Skip Tracing',
                href: '/service/skip-trace-phone-email-append',
                description:
                    'The Most Accurate and Cheapest service on the market!',
                icon: FingerPrintIcon,
            },
            // {
            //     name: 'Returned Mail Scanner',
            //     href: '/subscription/olm-returned-mail-scanner',
            // },
        ],
    },
    {
        name: 'Platform',
        childrens: [
            {
                name: 'Features',
                href: '/platform/features',
                description:
                    'Build, launch, and track direct mail campaigns from one platform.',
                icon: AdjustmentsIcon,
            },
            {
                name: 'Use Cases',
                href: '/platform/use-cases',
                description:
                    'Explore how teams use OLC for real estate, home services, agencies, and more.',
                icon: HomeIcon,
            },
            {
                name: 'Integrations',
                href: '/platform/integrations',
                description:
                    'Connect direct mail workflows with your CRM and marketing stack.',
                icon: ColorSwatchIcon,
            },
            {
                name: 'API & SDK',
                href: '/platform/api-sdk',
                description:
                    'Embed direct mail sending, webhooks, and automation into your software.',
                icon: MailIcon,
            },
        ],
    },
    // {
    //     name: 'Returned Mail Scanner',
    //     href: '/subscription/olm-returned-mail-scanner',
    // },
    {
        name: 'Coaching',
        href: '/coaching',
    },
    // {
    //     name: 'Reviews',
    //     href: '/reviews',
    // },
    {
        name: 'About',
        href: '#',
        childrens: [
            {
                name: 'About Us',
                href: '/about',
                icon: FingerPrintIcon,
            },
            {
                name: 'Reviews',
                href: '/reviews',
                icon: FingerPrintIcon,
            },
            {
                name: "Podcasts We're On ",
                href: '/podcasts',
                icon: FingerPrintIcon,
            },
            {
                name: 'Blog',
                href: '/blog',
                // target: '_blank',
                icon: FingerPrintIcon,
            },
            // {
            //     name: 'Reviews',
            //     href: '/reviews',
            //     icon: FingerPrintIcon,
            // },
        ],
    },
    {
        name: 'Contact',
        href: '/contact-us',
        // childrens: [
        //     {
        //         name: 'Contact Us',
        //         href: '/contact-us',
        //         icon: FingerPrintIcon,
        //     },
        //     {
        //         name: 'Reviews',
        //         href: '/reviews',
        //         icon: FingerPrintIcon,
        //     },
        //     // {
        //     //     name: 'Custom Quote',
        //     //     href: '/custom-quote',
        //     // },
        // ],
    },
    {
        name: 'Open Letter Connect',
        href: 'https://openletterconnect.com',
        target: '_blank',
    },
]

export const getHrefsFromNavigationsForPaths = () => {
    let hrefs = []

    // Helper function for recursion
    function helper(item) {
        if (item.href) {
            const slug = item.href.split('/').filter(Boolean).pop() // This removes any empty strings and takes the last part after '/'
            if (slug) {
                hrefs.push({ params: { slug } })
            }
        }

        if (item.childrens) {
            item.childrens.forEach((child) => helper(child))
        }
    }

    // Go through each item
    navigations.forEach((item) => helper(item))

    return hrefs
}
export const _CUSTOM_OFFER__KEY = 'Custom'

export const _isZeroTotalOrder = (order) => order && order.total == '0.00'

export const getTotalStoreCredits = (coupons) => {
    return coupons.reduce((total, coupon) => {
        return total + parseFloat(coupon.amount)
    }, 0)
}

export const withSentry = (handler) => handler

export const isCustomerUnAuthorized = (customer) => {
    if (!customer) return true
    return Boolean(customer?.unauthorized)
}

export const isValidCustomer = (customer) => {
    return !isCustomerUnAuthorized(customer)
}

export const isUserLoggedIn = () => {
    const user = UserStore.getState().user
    if (!user || !user?.ID) return false
    return true
}

export function sanitizeText(text) {
    if (!String(text)) return text
    return String(text)
        .replace(/\?/g, '') // Remove question marks
        .trim()
        .toLowerCase() // Convert to lowercase
        .replace(/[<>&'"]/g, '') // Remove specific characters
        .replace(/\s+/g, '-') // Replace spaces with hyphens
}

export const trackRevenueToBing = (revenueValue) => {
    if (window?.uetq) {
        window.uetq = window.uetq || []
        window.uetq.push('event', '', {
            revenue_value: revenueValue,
            currency: 'USD',
        })
        log('Bing Revenue Tracked')
    } else {
        log('Bing Revenue Not Tracked due to uetq not found')
    }
}

export const servicesProducts = [
    {
        name: 'Listsource Access',
        href: 'real-estate-investment-lead-lists',
        description:
            'Creating a comprehensive real estate investment lead list.',
        icon: ArchiveIcon,
    },
    {
        name: 'Skip Tracing',
        href: 'skip-trace-phone-email-append',
        description: 'The Most Accurate and Cheapest service on the market!',
        icon: FingerPrintIcon,
    },
]

export const subscriptionsProducts = [
    {
        name: 'OLM Returned Mail Scanner',
        href: 'olm-returned-mail-scanner',
        description:
            'OLM Returned Mail Scanner is only available for OLM direct mail customers.',
    },
]

export const _slugify = (string) => {
    return slugify(string, {
        replacement: '-', // replace spaces with replacement character, defaults to `-`
        remove: undefined, // remove characters that match regex, defaults to `undefined`
        lower: true, // convert to lower case, defaults to `false`
        strict: false, // strip special characters except replacement, defaults to `false`
        locale: 'vi', // language code of the locale to use
        trim: true, // trim leading and trailing replacement chars, defaults to `true`
    })
}

export const generateBlogPostLink = (post) => {
    const date = new Date(post.date)
    const year = date.getFullYear()
    const month = `0${date.getMonth() + 1}`.slice(-2)
    const day = `0${date.getDate()}`.slice(-2)
    return `/blog/${year}/${month}/${day}/${post.slug}`
}

export const getslugId = (item) => {
    return slugify(String(item).toLocaleLowerCase())
}

export const footerNavigations = {
    products: [
        { name: 'All Products', href: '/products' },
        { name: 'Campaigns', href: '/product/create-your-own-campaign' },
        {
            name: 'Offer Products <b>&#x2728;NEW!&#x2728;</b>',
            href: '/product/snap-pack-check-mailers-ros',
        },
        {
            name: 'Real Penned Products',
            href: `/products/#${getslugId('Handwritten Products')}`,
        },
        {
            name: 'Letters',
            href: `/products/#${getslugId('Professional Communications')}`,
        },
        {
            name: 'Flyers',
            href: `/products/#${getslugId('Self Mailers for Maximum Impact')}`,
        },
        {
            name: 'Postcards',
            href: `/products/#${getslugId(
                'Powerful Postcards for Every Purpose',
            )}`,
        },

        // slugify(String(item.name).toLocaleLowerCase())

        // {
        //     name: 'Real Penned Products',
        //     href: '#',
        // },
        // { name: 'Letters', href: '#' },
        // { name: 'Flyers', href: '#' },
        // { name: 'Postcards', href: '#' },
    ],
    resources: [
        // { name: 'Concierge Services', href: '#' },
        // {
        //     name: 'Get Free Samples',
        //     href: '/get-free-samples',
        // },
        // { name: 'Designs', href: '#' },
        // { name: 'FAQS', href: '#' },
        // {
        //     name: 'Blog',
        //     href: 'https://blog.openlettermarketing.com/',
        //     target: '_blank',
        // },
        {
            name: 'Create Account',
            href: '/create-account',
        },
        {
            name: 'New to Direct Mail? Start here.',
            href: '/get-started',
        },
        {
            name: 'Become an Affiliate',
            href: '/join-affiliate-program',
        },
        {
            name: 'Partners',
            href: '/partner-with-us',
        },
    ],
    discover: [
        // { name: 'Concierge Services', href: '#' },
        {
            name: 'Blog',
            href: '/blog',
        },
        {
            name: 'Direct To Seller Podcast',
            href: '/podcasts',
        },
        {
            name: 'Reviews',
            href: '/reviews',
        },
        {
            name: "FAQ's",
            href: '/FAQ',
        },
    ],

    company: [
        { name: 'About Us', href: '/about' },
        {
            name: 'Contact Us',
            href: '/contact-us',
            target: '_blank',
        },
        { name: 'Terms of Service', href: '/terms' },
        { name: 'Privacy Policy', href: '/privacy-policy' },
    ],
    social: [
        {
            name: 'Facebook',
            href: 'https://www.facebook.com/OpenLetterMktg/',
            target: '_blank',
            icon: (props) => (
                <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
                    <path
                        fillRule="evenodd"
                        d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
                        clipRule="evenodd"
                    />
                </svg>
            ),
        },
        {
            name: 'Instagram',
            href: 'https://www.instagram.com/openlettermktg/',
            target: '_blank',
            icon: (props) => (
                <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
                    <path
                        fillRule="evenodd"
                        d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
                        clipRule="evenodd"
                    />
                </svg>
            ),
        },
        {
            name: 'Mail',
            id: 'mailto',
            href: 'mailto:info@openlettermarketing.com',
            target: '_self',
            icon: (props) => <MailIcon className="h-5 w-5" {...props} />,
        },
    ],
}

export const removeSpaceFromString = (str) => {
    return String(str).replace(/\s/g, '-')
}

export const getWooCommerceSessionIdClientSide = () => {
    const cookieStr = document.cookie
    console.log('document.cookie', cookieStr)
    const match = cookieStr.match(/wooCommerceSessionKey=([^;]+)/)
    if (!match) return null

    const decoded = decodeURIComponent(match[1])

    // Now extract the wp_woocommerce_session_* value from the decoded string
    const sessionMatch = decoded.match(/wp_woocommerce_session_[^=]+=(\S+)/)
    if (!sessionMatch) return null

    const sessionId = sessionMatch[1].split('||')[0]
    return sessionId
}
